import React from 'react';
import { useSelector } from 'react-redux';
import { getSvg } from '../formData/formDataSlice';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Table, 
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
export function SvgResult() {
    const svg = useSelector(getSvg);  
    const [loading, setLoading] = React.useState(false);
    const downloadSVG = () =>{
        setLoading(true);
        let downloadLink = document.createElement("a");
        downloadLink.href = svg;
        downloadLink.download = "newesttree.svg";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        setLoading(false);
    }
    return (
      <section className="container left_section">
        <div style={{ width:"100%", height:"80%", display: "block", margin:" 0 auto ", backgroundColor: "rgb(250, 250, 250)"}}>
          <img style={{ height:"100%"}} src={svg} />
        </div>

        <TableContainer sx={{ height:"20%" }} component={Paper}>
        <Table sx={{ height:"100%" }} aria-label="simple table">
          <TableBody>
              <TableRow key={1} >
                <TableCell component="th" scope="row">
                  <LoadingButton
                    fullWidth
                    disabled={svg == '' ? true : false}
                    onClick={downloadSVG}
                    endIcon={<DownloadIcon />}
                    loading={loading}
                    loadingPosition="end"
                    variant="contained"
                  >
                    4. Download SVG
                  </LoadingButton>
                </TableCell>
              </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      </section>
    );
}
  